export const shadow = {
  popup: (color: string) => `0 0 2rem ${color}`,
  dialog: (color: string) => `0 0 5rem ${color}`
} as const;

export const calendarPickerFilter = 'invert(1) brightness(0.5)';
